/* WebSocket helper — abre conexão para /api/ws/case/{caseId} usando o mesmo
 * origin do backend (cookie raf_session é enviado automaticamente pelo browser).
 * Reconecta com backoff exponencial simples se a conexão cair.
 */
export function connectCaseWs(caseId, { onEvent, onOpen, onClose } = {}) {
  return _connect(`/api/ws/case/${caseId}`, { onEvent, onOpen, onClose });
}

export function connectBulkWs(bulkId, { onEvent, onOpen, onClose } = {}) {
  return _connect(`/api/ws/bulk/${bulkId}`, { onEvent, onOpen, onClose });
}

export function connectAdminCommsWs({ onEvent, onOpen, onClose } = {}) {
  return _connect(`/api/ws/admin/comms`, { onEvent, onOpen, onClose });
}

function _connect(path, { onEvent, onOpen, onClose } = {}) {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const wsBase = base.replace(/^http/i, "ws");
  const url = `${wsBase}${path}`;

  let ws = null;
  let backoff = 1000;
  let closed = false;

  const open = () => {
    if (closed) return;
    ws = new WebSocket(url);
    ws.onopen = () => { backoff = 1000; if (onOpen) onOpen(); };
    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.type === "ping") return;
        if (onEvent) onEvent(data);
      } catch (_err) { /* ignore malformed ws payload */ }
    };
    ws.onclose = () => {
      if (onClose) onClose();
      if (!closed) {
        setTimeout(open, Math.min(backoff, 15000));
        backoff = Math.min(backoff * 2, 15000);
      }
    };
    ws.onerror = () => { try { ws.close(); } catch (_err) { /* already closed */ } };
  };

  open();
  return { close: () => { closed = true; try { ws && ws.close(); } catch (_err) { /* already closed */ } } };
}
